// Kanten-Resize: eine Kante (l1/l2/b1/b2) nach außen/innen ziehen —
// das Maß ändert sich, die Gegenkante bleibt stehen. Engine-frei.
import { snapToGrid, rotateLocalVector } from "./snapping"
import { cutoutsOf, withCutouts, clampCutout } from "./cutouts"
import { cornersOf, clampCorners } from "./corners"
import { groovesOf, withGrooves, clampGroove } from "./machinings"

const MIN_DIM = 10

const OUTWARD = {
  l1: [ 0, 0, -1 ],
  l2: [ 0, 0, 1 ],
  b1: [ -1, 0, 0 ],
  b2: [ 1, 0, 0 ]
}

// Nach-außen-Normale der Kante in Weltkoordinaten (für die Drag-Projektion)
export function edgeOutwardWorld(part, edgeKey) {
  return rotateLocalVector(part, OUTWARD[edgeKey])
}

// Meta eines Teils NACH einer Maßänderung: Ausschnitte/Bohrungen, Ecken und
// Nuten/Fälze werden auf die neuen Maße geklemmt, damit beim Schrumpfen nichts
// aus der Platte ragt. `resized` ist das Teil mit den neuen Maßen.
// null = am meta ändert sich nichts (Teil ohne Bearbeitungen).
export function clampedMeta(part, resized) {
  let meta = part.meta
  if (cutoutsOf(part).length > 0) {
    meta = withCutouts({ ...resized, meta }, cutoutsOf(part).map((c) => clampCutout(c, resized)))
  }
  if (Object.keys(cornersOf(part)).length > 0) {
    meta = clampCorners({ ...resized, meta })
  }
  if (groovesOf(part).length > 0) {
    meta = withGrooves({ ...resized, meta }, groovesOf(part).map((g) => clampGroove(g, resized)))
  }
  return meta === part.meta ? null : meta
}

// deltaMm > 0 = Kante nach außen ziehen (größer). Liefert neue Maße + Position
// (Mittelpunkt wandert um die halbe Maßänderung entlang der Kantennormale).
export function resizeByEdge(part, edgeKey, deltaMm, gridMm = 10) {
  const dimField = edgeKey.startsWith("l") ? "width_mm" : "length_mm"
  const newDim = Math.max(MIN_DIM, snapToGrid(part[dimField] + deltaMm, gridMm))
  const applied = newDim - part[dimField]
  if (applied === 0) return null

  const outward = edgeOutwardWorld(part, edgeKey)
  const shift = applied / 2
  return {
    [dimField]: newDim,
    pos_x: Math.round(part.pos_x + outward[0] * shift),
    pos_y: Math.round(part.pos_y + outward[1] * shift),
    pos_z: Math.round(part.pos_z + outward[2] * shift)
  }
}
